import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import { UserBet } from "../../models/UserBet";
import "./OpenBets.scss";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import closeIcon from "../../assets/images/close.png";
import { useSnackbar } from "notistack";
import CircularProgress from "@mui/material/CircularProgress";
import API from "../../services";
import { USER_API } from "../../services";

type StoreProps = {
  provider: string;
  openBets: UserBet[];
};

const OpenBets: React.FC<StoreProps> = (props) => {
  const { openBets, provider } = props;
  const [loading, setLoading] = useState<boolean>(false);
  const { enqueueSnackbar } = useSnackbar();
  let providerId = sessionStorage.getItem("psProviderId");
  const getUnmatchedBets = (bets: UserBet[]) => {
    const unmatchedBets = bets.filter((bet: UserBet) => {
      return bet?.isUnmatched;
    });

    return unmatchedBets;
  };
  const getMatchedBets = (bets: UserBet[]) => {
    const matchedBets = bets?.filter((bet: UserBet) => {
      return !bet.isUnmatched;
    });

    return matchedBets;
  };

  const cancelBet = async (bet: UserBet) => {
    if (loading) return true;
    try {
      setLoading(true);
      const postBody = {
        token: sessionStorage.getItem("user_api_token"),
        operatorId: sessionStorage.getItem("psOperatorId"),
        providerId: sessionStorage.getItem("psProviderId"),
        cancelBets: [{ betId: bet.betId, cancelSize: 0 }],
        marketId: bet.marketId,
        eventId: bet.eventId,
        sportId: bet.sportId,
      };
      const response: any = await USER_API.post("/cancel-bets", postBody);

      if (
        response?.data?.status === "RS_OK" &&
        response?.data?.errorDescription === ""
      ) {
        setLoading(false);
        return enqueueSnackbar("Bet deleted successful.", {
          variant: "success",
        });
      } else {
        setLoading(false);
        return enqueueSnackbar("Bet is not canceled, Please try again.", {
          variant: "error",
        });
      }
    } catch (err) {
      setLoading(false);
    }
  };

  return (
    <>
      {provider === "sp" ? (
        <div className="open-bets-ctn">
          <TableContainer className="open-bets-tbl">
            <Table size="small" className="open-table">
              <TableHead className="table-heading">
                <TableRow>
                  <TableCell className="cell">Market</TableCell>
                  <TableCell className="cell" align="right">
                    Odds
                  </TableCell>
                  <TableCell className="cell" align="right">
                    Stake
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody className="open-bets-table-body">
                {getMatchedBets(openBets)?.length > 0 ? (
                  <>
                    {getMatchedBets(openBets).map((bet, idx) => (
                      <>
                        {!bet.unmatched ? (
                          <TableRow
                            key={"row" + idx}
                            className={
                              bet.betType === "BACK"
                                ? "back-bet open-bets-table-row"
                                : "lay-bet open-bets-table-row"
                            }
                          >
                            <TableCell
                              key={"market-cell-row" + idx}
                              className="open-bets-table-cell"
                            >
                              {bet.sportId?.length > 2 ? (
                                <>
                                  <div>{bet?.marketName}</div>
                                  <div>
                                    <b>Bet On: </b>
                                    {bet.runnerName}
                                  </div>
                                </>
                              ) : (
                                <div>
                                  {bet.marketType} {" - "} {bet.runnerName}
                                </div>
                              )}
                            </TableCell>
                            <TableCell
                              key={"odds-cell-row" + idx}
                              align="right"
                              className="open-bets-table-cell"
                            >
                              {bet.marketType === "FANCY"
                                ? Number(bet.sessionOutcome).toFixed(0)
                                : bet.oddValue.toFixed(2)}
                            </TableCell>
                            <TableCell
                              key={"stake-cell-row" + idx}
                              align="right"
                              className="open-bets-table-cell"
                            >
                              {bet?.stakeAmount}
                            </TableCell>
                          </TableRow>
                        ) : null}
                      </>
                    ))}
                  </>
                ) : (
                  <TableRow>
                    <TableCell colSpan={4}>
                      <div className="no-data"> No Matched Bets Found.</div>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      ) : (
        <div className="open-bets-ctn">
          <Accordion className="open-ctn" defaultExpanded={true}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography>
                Matched Bets ({getMatchedBets(openBets)?.length})
              </Typography>
            </AccordionSummary>
            <AccordionDetails className="accordion-detail">
              <TableContainer className="open-bets-tbl">
                <Table size="small" className="open-table">
                  <TableHead className="table-heading">
                    <TableRow>
                      <TableCell className="cell">Market</TableCell>
                      <TableCell className="cell" align="right">
                        Odds
                      </TableCell>
                      <TableCell className="cell" align="right">
                        Stake
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody className="open-bets-table-body">
                    {getMatchedBets(openBets)?.length > 0 ? (
                      <>
                        {getMatchedBets(openBets).map((bet, idx) => (
                          <>
                            {!bet.unmatched ? (
                              <TableRow
                                key={"row" + idx}
                                className={
                                  bet.betType === "BACK"
                                    ? "back-bet open-bets-table-row"
                                    : "lay-bet open-bets-table-row"
                                }
                              >
                                <TableCell
                                  key={"market-cell-row" + idx}
                                  className="open-bets-table-cell"
                                >
                                  {bet.sportId?.length > 2 ? (
                                    <>
                                      <div>{bet?.marketName}</div>
                                      <div>
                                        <b>Bet On: </b>
                                        {bet.runnerName}
                                      </div>
                                    </>
                                  ) : (
                                    <div>
                                      {bet.marketType} {" - "} {bet.runnerName}
                                    </div>
                                  )}
                                </TableCell>
                                <TableCell
                                  key={"odds-cell-row" + idx}
                                  align="right"
                                  className="open-bets-table-cell"
                                >
                                  {bet.marketType === "FANCY"
                                    ? Number(bet.sessionOutcome).toFixed(0)
                                    : bet.oddValue.toFixed(2)}
                                </TableCell>
                                <TableCell
                                  key={"stake-cell-row" + idx}
                                  align="right"
                                  className="open-bets-table-cell"
                                >
                                  {bet?.stakeAmount}
                                </TableCell>
                              </TableRow>
                            ) : null}
                          </>
                        ))}
                      </>
                    ) : (
                      <TableRow>
                        <TableCell colSpan={4}>
                          <div className="no-data"> No Matched Bets Found.</div>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </AccordionDetails>
          </Accordion>
          {providerId === "BetFair" ? (
            <>
              <Accordion className="open-ctn" defaultExpanded={true}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  className="accordian"
                >
                  <Typography>
                    Unmatched Bets ({getUnmatchedBets(openBets).length})
                  </Typography>
                </AccordionSummary>
                <AccordionDetails className="accordion-detail">
                  <TableContainer>
                    <Table size="small" className="open-table">
                      <TableHead className="table-heading">
                        <TableRow>
                          <TableCell className="cell">Market</TableCell>
                          <TableCell className="cell" align="right">
                            Odds
                          </TableCell>
                          <TableCell className="cell" align="right">
                            Stake
                          </TableCell>

                          <TableCell className="cell" align="right">
                            Action
                          </TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody className="open-bets-table-body">
                        {loading ? (
                          <TableRow>
                            <TableCell colSpan={4} align="center">
                              <div className="centered">
                                <CircularProgress className="icon" />
                              </div>{" "}
                            </TableCell>
                          </TableRow>
                        ) : (
                          <>
                            {getUnmatchedBets(openBets)?.length > 0 ? (
                              <>
                                {getUnmatchedBets(openBets).map((bet, idx) => (
                                  <>
                                    {!bet.unmatched ? (
                                      <TableRow
                                        key={"row" + idx}
                                        className={
                                          bet.betType === "BACK"
                                            ? "back-bet open-bets-table-row"
                                            : "lay-bet open-bets-table-row"
                                        }
                                      >
                                        <TableCell
                                          key={"market-cell-row" + idx}
                                          className="open-bets-table-cell"
                                        >
                                          {bet.marketName} - {bet.runnerName}
                                        </TableCell>
                                        <TableCell
                                          key={"odds-cell-row" + idx}
                                          align="right"
                                          className="open-bets-table-cell"
                                        >
                                          {bet.oddValue}
                                        </TableCell>
                                        <TableCell
                                          key={"stake-cell-row" + idx}
                                          align="right"
                                          className="open-bets-table-cell"
                                        >
                                          {bet?.stakeAmount}
                                        </TableCell>

                                        <TableCell
                                          key={"stake-cell-row" + idx}
                                          align="center"
                                        >
                                          <img
                                            className="close-icon"
                                            src={closeIcon}
                                            alt="close"
                                            onClick={() => cancelBet(bet)}
                                          />
                                        </TableCell>
                                      </TableRow>
                                    ) : null}
                                  </>
                                ))}
                              </>
                            ) : (
                              <TableRow>
                                <TableCell colSpan={4}>
                                  <div className="no-data">
                                    {" "}
                                    No UnMatched Bets Found.
                                  </div>
                                </TableCell>
                              </TableRow>
                            )}
                          </>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </AccordionDetails>
              </Accordion>
            </>
          ) : null}
        </div>
      )}
    </>
  );
};

export default OpenBets;
